import { ChevronRightIcon, WrenchIcon } from "lucide-react";

import type { ChatToolCall } from "~/ai-chat/model/chat-message";
import { toolCallsLabel } from "~/ai-chat/model/tool-activity";
import { cn } from "~/utils/cn";

interface ChatToolCallsSummaryProps {
  calls: ChatToolCall[];
  expanded: boolean;
  onToggle: () => void;
}

// The line under a reply that used tools: how many ran and how many failed. Expands the transcript in place.
export function ChatToolCallsSummary({ calls, expanded, onToggle }: ChatToolCallsSummaryProps) {
  const failed = calls.filter((call) => call.outcome?.ok === false).length;
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={expanded}
      className="text-muted-foreground hover:text-foreground flex w-fit items-center gap-1.5 text-xs transition-colors"
    >
      <ChevronRightIcon className={cn("size-3 transition-transform", expanded && "rotate-90")} aria-hidden="true" />
      <WrenchIcon className="size-3" aria-hidden="true" />
      <span>{toolCallsLabel(calls)}</span>
      {failed > 0 ? <span className="text-destructive">· {failed} failed</span> : null}
    </button>
  );
}
